const Button = ({text, func=() => {}, clickable=true, variant="primary", className="", type="button"}) => {
    const OnClick = (event) => {
        event.preventDefault();
        if (clickable) {
            func();
        }
    }

    const variants = {
        primary: "bg-[#176b87] text-white shadow-[0_8px_18px_rgba(23,107,135,0.2)] hover:bg-[#0f5269]",
        secondary: "border border-slate-200 bg-white text-slate-700 shadow-sm hover:border-cyan-300 hover:bg-cyan-50",
        danger: "border border-red-200 bg-red-50 text-red-700 shadow-sm hover:bg-red-100",
        ghost: "bg-transparent text-slate-600 hover:bg-slate-100"
    };

    return <button
        type={type}
        disabled={!clickable}
        aria-disabled={!clickable}
        className={`inline-flex min-h-[2.75rem] items-center justify-center rounded-xl px-5 py-2.5 text-sm font-bold tracking-wide transition duration-200 hover:-translate-y-0.5 focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400 disabled:shadow-none disabled:hover:translate-y-0 ${variants[variant] || variants.primary} ${className}`}
        onClick={type === "button" ? OnClick : undefined}
    >
        {text}
    </button>
}

export default Button;
